/* PS AFEX — shared boot: ambient glow, sticky nav, reveal, audio tick */
(function () {
  if (window.__PS_AFEX_BOOT__) return;
  window.__PS_AFEX_BOOT__ = true;

  window.PS_AFEX = window.PS_AFEX || {
    userName: '',
    playTick: null
  };

  var NAME_STORAGE_KEY = 'ps-afex-userName';

  function hasValidName(name) {
    return !!(name && name !== 'Guest');
  }

  /* Token replace: {name}, {recipe}, etc. — returns plain string for textContent */
  function formatPersonal(template, tokens) {
    if (!template) return '';
    tokens = tokens || {};
    return String(template).replace(/\{(\w+)\}/g, function (_, key) {
      return tokens[key] != null ? String(tokens[key]) : '';
    });
  }

  /* Scan [data-ps-afex-personalize]; use fallback when no valid name */
  function applyPersonalization() {
    var name = window.PS_AFEX.userName;
    var valid = hasValidName(name);
    document.querySelectorAll('[data-ps-afex-personalize]').forEach(function (el) {
      var template = el.getAttribute('data-ps-afex-personalize');
      var fallback = el.getAttribute('data-ps-afex-fallback');
      if (valid && template) {
        el.textContent = formatPersonal(template, { name: name });
      } else if (fallback != null) {
        el.textContent = fallback;
      }
    });
  }

  function setUserName(name) {
    name = (name || '').trim();
    window.PS_AFEX.userName = name;
    try {
      if (hasValidName(name)) {
        sessionStorage.setItem(NAME_STORAGE_KEY, name);
      } else {
        sessionStorage.removeItem(NAME_STORAGE_KEY);
      }
    } catch (e) {}
    applyPersonalization();
    try {
      document.dispatchEvent(new CustomEvent('ps-afex:username', { detail: { name: name } }));
    } catch (e) {}
  }

  window.PS_AFEX.formatPersonal = formatPersonal;
  window.PS_AFEX.applyPersonalization = applyPersonalization;
  window.PS_AFEX.setUserName = setUserName;
  window.PS_AFEX.hasValidName = hasValidName;

  /* Ambient glow follows cursor */
  var ambient = document.getElementById('ps-afex-ambient');
  if (ambient) {
    document.addEventListener('mousemove', function (e) {
      ambient.style.setProperty('--mx', e.clientX + 'px');
      ambient.style.setProperty('--my', e.clientY + 'px');
    });
  }

  /* Subtle click sound (WebAudio, no assets) */
  var audioCtx;
  function playTick(freq, duration, type, gain) {
    freq = freq == null ? 440 : freq;
    duration = duration == null ? 0.06 : duration;
    type = type || 'sine';
    gain = gain == null ? 0.05 : gain;
    try {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
      var osc = audioCtx.createOscillator();
      var g = audioCtx.createGain();
      osc.type = type;
      osc.frequency.value = freq;
      g.gain.value = gain;
      osc.connect(g);
      g.connect(audioCtx.destination);
      osc.start();
      g.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + duration);
      osc.stop(audioCtx.currentTime + duration);
    } catch (e) {}
  }
  window.PS_AFEX.playTick = playTick;

  /* Reveal on scroll */
  function bindReveal() {
    var revealEls = document.querySelectorAll('.ps-afex .reveal');
    if (!revealEls.length || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('in');
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* Sticky nav dial (bottom pill) */
  function bindNav() {
    var navDial = document.getElementById('ps-afex-navDial');
    if (!navDial) return;
    document.documentElement.classList.add('ps-afex-nav-on');

    var navKnob = document.getElementById('ps-afex-navKnob');
    var navLabels = navDial.querySelectorAll('.nav-label:not(.nav-shop)');
    var navShop = navDial.querySelector('.nav-shop');
    var shopTriggerId = navDial.getAttribute('data-shop-trigger');
    var shopTrigger = shopTriggerId ? document.getElementById(shopTriggerId) : null;

    function sectionIdForLabel(label) {
      return label.getAttribute('data-target');
    }

    var shopMode = false;
    function updateShopMode() {
      if (!navShop || !shopTrigger) return;
      var rect = shopTrigger.getBoundingClientRect();
      var past = rect.bottom <= window.innerHeight * 0.4;
      if (past === shopMode) return;
      shopMode = past;
      navDial.classList.toggle('shop-mode', shopMode);
      navShop.textContent = shopMode
        ? navShop.getAttribute('data-label-shop')
        : navShop.getAttribute('data-label-default');
    }

    var lastCurrent = '';
    window.addEventListener('scroll', function () {
      if (window.scrollY > window.innerHeight * 0.5) {
        navDial.classList.add('visible');
      }
      updateShopMode();
      var current = '';
      document.querySelectorAll('.ps-afex-section[id]').forEach(function (sec) {
        var rect = sec.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.4 && rect.bottom >= window.innerHeight * 0.4) {
          current = sec.id;
        }
      });
      if (current === lastCurrent) return;
      lastCurrent = current;
      var activeLabel = null;
      navLabels.forEach(function (l) {
        var isActive = sectionIdForLabel(l) === current;
        l.classList.toggle('active', isActive);
        if (isActive) activeLabel = l;
      });
      if (activeLabel && !shopMode) {
        try {
          activeLabel.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        } catch (e) {}
      }
    }, { passive: true });

    navLabels.forEach(function (label) {
      label.addEventListener('click', function () {
        if (navKnob) {
          navKnob.classList.remove('spin');
          void navKnob.offsetWidth;
          navKnob.classList.add('spin');
        }
        playTick(300 + Math.random() * 200, 0.08, 'square', 0.04);
        var target = document.getElementById(sectionIdForLabel(label));
        if (target) {
          /* Bottom nav: clear sticky site header only */
          var offset = 72;
          var y = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        }
        try {
          label.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        } catch (e) {}
      });
    });

    if (navShop) {
      navShop.addEventListener('click', function () {
        playTick(300 + Math.random() * 200, 0.08, 'square', 0.04);
      });
    }

    window.PS_AFEX.showNav = function () {
      navDial.classList.add('visible');
    };
  }

  function restoreUserName() {
    try {
      var stored = sessionStorage.getItem(NAME_STORAGE_KEY);
      if (hasValidName(stored)) {
        window.PS_AFEX.userName = stored;
      }
    } catch (e) {}
    applyPersonalization();
  }

  function init() {
    bindReveal();
    bindNav();
    restoreUserName();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
